module.exports = __webpack_public_path__ + "img/wode.7cae316b.png";